module.exports = __webpack_public_path__ + "img/component-1.e9debcfe.svg";